import { apiClient } from '../config';

export interface ClubBranding {
  logo_url: string;
  primary_color: string;
  secondary_color: string;
  accent_color: string;
  font_family: string;
  font_heading: string;
}

export interface ClubSettings {
  timezone: string;
  currency: string;
  date_format: string;
}

export interface NotificationPreferences {
  email_notifications: boolean;
  push_notifications: boolean;
  daily_digest: boolean;
  weekly_report: boolean;
}

export interface Club {
  id: string;
  name: string;
  industry: string;
  members_count: number;
  branding: ClubBranding;
  settings: ClubSettings;
  role: 'owner' | 'platform_admin' | 'manager' | 'staff' | 'viewer' | 'read_only' | string;
  permissions: string[];
  notification_preferences: NotificationPreferences;
}

export interface GetClubsResponse {
  clubs: Club[];
  is_platform_admin: boolean;
}

export const clubsApi = {
  getMyClubs: async (): Promise<GetClubsResponse> => {
    const response = await apiClient.get<GetClubsResponse>('/api/me/clubs');
    return response.data;
  },
};
